document.documentElement.classList.add("no-transition");

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".product-tab-btn");
  const products = document.querySelectorAll(".tab-product");
  const tabsContainer = document.querySelector(".product-tabs-container");
  const fallbackContainer = document.querySelector(".fallback-product-template");

  // ---- helpers for persistent inner-tab state ----
  const LS_KEY = "innerTabStateByHandle"; // { [handle]: index }
  function readState() {
    try {
      return JSON.parse(localStorage.getItem(LS_KEY) || "{}");
    } catch {
      return {};
    }
  }
  function writeState(obj) {
    localStorage.setItem(LS_KEY, JSON.stringify(obj));
  }
  function setInnerIndex(handle, index) {
    const s = readState();
    s[handle] = index;
    writeState(s);
  }
  function getInnerIndex(handle, fallback = 0) {
    const s = readState();
    const idx = Number.isInteger(s[handle]) ? s[handle] : fallback;
    return idx;
  }

  function activateTabByHandle(handle) {
    // outer actives
    buttons.forEach((b) => b.classList.remove("active"));
    products.forEach((p) => p.classList.remove("active"));

    const activeBtn = document.querySelector(`.product-tab-btn[data-handle="${handle}"]`);
    const activeProduct = document.querySelector(`.tab-product[data-product="${handle}"]`);

    if (activeBtn && activeProduct) {
      activeBtn.classList.add("active");
      activeProduct.classList.add("active");
      // restore inner tab for this product (persisted)
      restoreInnerTabState(handle, activeProduct);
      return true;
    }
    return false;
  }

  // ✅ Tab click → full page navigation (no pushState)
  buttons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.handle;
      if (tabsContainer) tabsContainer.style.pointerEvents = "none";
      window.location.href = `/products/${handle}`;
    });
  });

  // Initial activation for current page
  const currentHandle = window.location.pathname.split("/").pop();
  const found = activateTabByHandle(currentHandle);

  if (found) {
    if (tabsContainer) tabsContainer.style.visibility = "visible";
  } else {
    if (tabsContainer) tabsContainer.style.display = "none";
    if (fallbackContainer) {
      fallbackContainer.style.display = "block";
      fallbackContainer.style.visibility = "visible";
    }
  }

  // ========== INNER TAB SYSTEM ==========
  function initInnerTabs() {
    const productNodes = document.querySelectorAll(".tab-product");

    productNodes.forEach((product) => {
      const handle = product.dataset.product;
      const innerButtons = product.querySelectorAll(".metafield-tab-btn");
      const contents = product.querySelectorAll(".metafield-tab-content");

      // On first load, DON'T clear if already correct; apply persisted state
      applyInnerIndex(handle, product, getInnerIndex(handle, 0), { avoidUnnecessaryClear: true });

      innerButtons.forEach((btn, index) => {
        btn.addEventListener("click", function () {
          // normal tab behavior (exclusive within same product)
          applyInnerIndex(handle, product, index);
          // persist for this product (survives page change/reload)
          setInnerIndex(handle, index);
        });
      });
    });
  }

  function applyInnerIndex(handle, productNode, index, opts = {}) {
    const avoidClear = opts.avoidUnnecessaryClear;

    const innerButtons = productNode.querySelectorAll(".metafield-tab-btn");
    const contents = productNode.querySelectorAll(".metafield-tab-content");

    const currentBtn = productNode.querySelector(".metafield-tab-btn.active-on");
    const currentIdx = currentBtn ? Array.from(innerButtons).indexOf(currentBtn) : -1;

  
    if (avoidClear && currentIdx === index) return;

    
    innerButtons.forEach((b) => b.classList.remove("active-on"));
    contents.forEach((c) => c.classList.remove("active-on"));

    if (innerButtons[index] && contents[index]) {
      innerButtons[index].classList.add("active-on");
      contents[index].classList.add("active-on");
    }
  }

  function restoreInnerTabState(handle, activeProduct) {
   
    const index = getInnerIndex(handle, 0);

    
    applyInnerIndex(handle, activeProduct, index, { avoidUnnecessaryClear: true });
  }

  initInnerTabs();

  
  document.documentElement.classList.remove("no-transition");
  document.documentElement.classList.add("tabs-ready");
});



//combo-product-tab
document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".combo-tab-btn");
    const contents = document.querySelectorAll(".content-combo");

    buttons.forEach((btn) => {
      btn.addEventListener("click", function () {
        const handle = this.getAttribute("data-handle");

        // Remove active states
        buttons.forEach((b) => b.classList.remove("active-head"));
        contents.forEach((c) => c.classList.remove("active-content"));

        // Activate selected tab and content
        this.classList.add("active-head");
        const activeContent = document.querySelector(`.content-combo[data-handle="${handle}"]`);
        if (activeContent) activeContent.classList.add("active-content");
      });
    });
  });

//slider
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('media-gallery').forEach(function (gallery) {

    const thumbnails = gallery.querySelectorAll(
      '#Slider-Thumbnails-' + gallery.dataset.sectionId + ' .thumbnail'
    );

    const prevBtn = gallery.querySelector('.slider-button--prev');
    const nextBtn = gallery.querySelector('.slider-button--next');

    if (!thumbnails.length || !prevBtn || !nextBtn) return;

    let index = 0;

    function clickThumbnail(i) {
      thumbnails[i]?.click();
    }

    nextBtn.addEventListener('click', function () {
      if (index < thumbnails.length - 1) {
        index++;
        clickThumbnail(index);
      }
    });

    prevBtn.addEventListener('click', function () {
      if (index > 0) {
        index--;
        clickThumbnail(index);
      }
    });

  });

});

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('media-gallery').forEach(function (gallery) {

    const track = gallery.querySelector('.product__media-list');
    const thumbnails = gallery.querySelectorAll(
      '#Slider-Thumbnails-' + gallery.dataset.sectionId + ' .thumbnail'
    );

    if (!track || !thumbnails.length) return;

    let index = 0;
    let startX = 0;
    let dragging = false;

    function goTo(i) {
      thumbnails[i]?.click();
    }

    track.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      dragging = true;
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;

      const diff = e.clientX - startX;

      // swipe threshold
      if (Math.abs(diff) > 60) {
        dragging = false;

        if (diff < 0 && index < thumbnails.length - 1) {
          index++;
          goTo(index);
        } else if (diff > 0 && index > 0) {
          index--;
          goTo(index);
        }
      }
    });

    track.addEventListener('pointerup', function () {
      dragging = false;
    });

    track.addEventListener('pointerleave', function () {
      dragging = false;
    });

  });

});



// let userMutedVideo = false;

// document.addEventListener('volumechange', (e) => {
//   if (e.target.tagName === 'VIDEO') {
//     userMutedVideo = e.target.muted;
//   }
// }, true);

// function handleProductVideoSound() {
//   document.querySelectorAll('.product__media video, .media video').forEach(video => {
//     if (!video.paused && !userMutedVideo) {
//       video.muted = false;
//       video.volume = 1;
//     }
//   });
// }

// document.addEventListener('click', () => {
//   setTimeout(handleProductVideoSound, 300);
// });

//video

let userMutedVideo = false;

// Track user mute action
document.addEventListener('volumechange', (e) => {
  if (e.target.tagName === 'VIDEO') {
    userMutedVideo = e.target.muted;
  }
}, true);

function playActiveSlideVideo() {
  const activeSlide = document.querySelector('.product__media-item.is-active video, .media.is-active video');

  if (activeSlide) {
    activeSlide.pause(); // reset first
    activeSlide.currentTime = 0;

    activeSlide.muted = userMutedVideo ? true : false;
    activeSlide.play().catch(err => {
      console.log("Autoplay blocked:", err);
    });
  }
}

// Detect slider change (Shopify Dawn uses this event)
document.addEventListener('slideChanged', () => {
  setTimeout(playActiveSlideVideo, 200);
});

// Fallback: click on thumbnail
document.querySelectorAll('.thumbnail').forEach(thumbnail => {
  thumbnail.addEventListener('click', () => {
    setTimeout(playActiveSlideVideo, 300);
  });
});

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(playActiveSlideVideo, 500);
});
